import { render } from "./PgyCheckBox.vue?vue&type=template&id=21c579d1&scoped=true"
import script from "./PgyCheckBox.vue?vue&type=script&lang=js"
export * from "./PgyCheckBox.vue?vue&type=script&lang=js"

import "./PgyCheckBox.vue?vue&type=style&index=0&id=21c579d1&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c579d1"]])

export default __exports__